import React from 'react'
//import Parser from 'html-react-parser'

export default (props) => {
  const content = () => {
    const slug= props.slug.toLowerCase()
    const url = props.match.toLowerCase()
    if (slug === url){
      return (
        <div>
          {props.title} - {props.object} - {props.id}
          <div dangerouslySetInnerHTML={{__html: props.content}}></div>
        </div>
      )
    }
    else if( Object.keys(props.is_category).length !== 0 ){
      return(
        <div>
          {props.title} - {props.object} - {props.id}
          <div dangerouslySetInnerHTML={{__html: props.content}}></div>
        </div>
      )
    }
  }
  return(
    <div data-c="PageSingle">
      {content()}
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/pages/PageSingle.js